import React from 'react'
import "../styles/SearchResult.css"

const SearchResult = ({handleSelectActor, actorName}) => {
  return (
    <div className="search-result-container" onClick={() => handleSelectActor(actorName)}>
      <h3>
        {actorName}
      </h3>
    </div>
  )
}

export default SearchResult